// Texto neutro exibido no lugar do telefone quando o contato ainda não tem
// um número confirmado (contact.phoneUnconfirmed vindo da API, calculado em
// backend/src/helpers/ContactPhoneStatus.ts). Nunca exibir os dígitos do
// LID como se fossem o "Número do WhatsApp".
export const UNCONFIRMED_PHONE_LABEL = "Número ainda não identificado";

export const getContactPhoneDisplay = (contact, formattedNumber) => {
	if (contact && contact.phoneUnconfirmed) {
		return UNCONFIRMED_PHONE_LABEL;
	}
	return formattedNumber;
};

// Texto neutro exibido quando o contato não tem nome salvo (name vazio).
// O backend nunca mais grava os dígitos do LID como nome (ver
// backend/src/helpers/ContactPhoneStatus.ts, resolveVerifyContactFallbackName
// e resolveFromMeContactName) — o resultado é um `name` vazio nesses casos,
// que precisa de um texto neutro só na exibição, sem inventar/persistir
// nenhum nome.
export const UNKNOWN_CONTACT_NAME_LABEL = "Contato sem nome";

export const getContactNameDisplay = contact => {
	const name = contact && contact.name;
	return name && String(name).trim() !== "" ? name : UNKNOWN_CONTACT_NAME_LABEL;
};

export default getContactPhoneDisplay;
